import { createSlice } from '@reduxjs/toolkit';
import { catalog, objectId } from '../../apis/local/catalog';

const initialState = {
    isInitialized: false,
    isLoading: false,
    error: null,
    items: []
};

const Cart = catalog('cart');

export const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        initialize: (state) => {
            state.isInitialized = true;
            state.isLoading = false;
            state.items = Cart.all();
        },
        clearCart: (state) => {
            Cart.all().forEach((item) => Cart.remove(item.id));
            state.items = Cart.all();
        },
        addToCart: (state, action) => {
            const { product, quantity } = action.payload;
            const current = Cart.all().find((item) => item.product.id === product.id);
            if (current) {
                Cart.update(current.id, { ...current, quantity: current.quantity + quantity });
            } else {
                Cart.add({ id: objectId(), product, quantity });
            }
            state.items = Cart.all();
        },
        updateCartItem: (state, action) => {
            Cart.update(action.payload.id, action.payload);
            state.items = Cart.all();
        },
        removeCartItem: (state, action) => {
            Cart.remove(action.payload.id);
            state.items = Cart.all();
        }
    }
});

// State
export const isInitialized = (state) => state.cart.isInitialized;
export const isLoading = (state) => state.cart.isLoading;
export const error = (state) => state.cart.error;
export const items = (state) => state.cart.items;

// Actions
export const { initialize, clearCart, addToCart, updateCartItem, removeCartItem } =
    cartSlice.actions;

// Reducer
export default cartSlice.reducer;
